import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { TranslocoService } from '@ngneat/transloco';
import { TranslocoDecimalPipe } from '@ngneat/transloco-locale';
import { saveAs } from 'file-saver';
import { ConfigService } from '../config/config.service';
import { HomeSelectionEnum } from '../enums';
import { FileTypeEnum } from '../enums/file-types.enum';

@Injectable({
  providedIn: 'root',
})
export class CommonHelper {
  constructor(private translocoDecimalPipe: TranslocoDecimalPipe, private readonly configSrv: ConfigService, private readonly transloco: TranslocoService) { }

  /**
   * verilen tipe göre dosyaların indirilmesini sağlayan method.
   * @param data
   */
  public downloadFile(data: any, type?: number, fileName?: string): void {
    const binaryString = window.atob(data);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }

    let switchType: string;
    let fileExt: string;
    fileName = fileName ? fileName : new Date().toISOString() + '_';

    switch (type) {
      case FileTypeEnum.EXCEL:
        switchType = 'application/vnd.ms.excel';
        fileExt = '.xls';
        break;

      case FileTypeEnum.PDF:
        switchType = 'application/pdf';
        fileExt = '.pdf';
        break;

      default:
        break;
    }

    const blob = new Blob([bytes], { type: switchType });
    const file = new File([blob], fileName + fileExt, {
      type: switchType,
    });

    saveAs(file);
  }

  /**
   * calculate percentages
   * @param {array} arr
   */
  public calculatePercentages(arr: number[], type?: string): number | string {
    let percentage: any;
    let calcAverage: any;
    const maxAverage = 1000;

    // Tüm enerji ve TEP seçilmişse average değeri dönüyoruz işleme devam etmiyoruz.
    if (type === 'stacked') {
      percentage = arr;
    }

    // 2 değer arasında ki average farkını hesaplıyoruz.
    else if ((arr[0] !== null) && (arr[1] !== null)) {
      const A = arr[0];
      const B = arr[1];
      percentage = ((B - A) / B) * 100;

      if (isNaN(percentage) || !isFinite(percentage) || A === 0 || B === 0 || !arr) {
        percentage = null;
      }
    }
    else {
      percentage = null;
    }

    if (percentage != null) {
      // hesaplanan avaraj 0 ile 1 arasında ise "-" gösteriyoruz.
      if (percentage > -1 && percentage < 1) {
        calcAverage = '';

      } else {

        // hesaplanan avaraj 1000+ veya -1000+ ise özel gösterim yapıyoruz.
        if (percentage > maxAverage || percentage < -maxAverage) {
          calcAverage = (percentage < maxAverage) ? `<span class="color-red">&gt;+${maxAverage}%</span>` : `<span class="color-green">&lt;-${maxAverage}%</span>`;
        } else {
          // değilse normal avarajları dönüyoruz.
          calcAverage = (percentage < 0) ? `<span class="color-red">+${this.formatterNumber(Number(percentage) * -1)}%</span>` : `<span class="color-green">-${this.formatterNumber(percentage)}%</span>`;
        }
      }

      return calcAverage;

    } else {
      return '';
    }
  }

  /**
   * number formatter
   * @param val
   */
  public formatterNumber(val: string | number): string | number {
    return this.translocoDecimalPipe.transform(val, this.configSrv.configuration.numberFormatOptions);
  }

  /**
   * chart serie formatter
   * @param val
   */
  public formatterSerie(val: number | string): number | string {
    return (val !== null) ? this.translocoDecimalPipe.transform(val, this.configSrv.configuration.numberFormatOptions) : '-';
  }

  /**
   * ana sayfa seçimine yönlendiriyoruz.
   * @param pageId
   */
  public homePageRedirect(pageId: number): void {

    // page id
    switch (pageId) {
      // ana panel seçildiyse
      case HomeSelectionEnum.MainPanel:
        window.location.href = environment.tempUrl + '?lang=' + this.transloco.getActiveLang();
        break;

      // tesis yönetimi seçildiyse
      case HomeSelectionEnum.FacilityManager:
        window.location.href = environment.tempUrl + '/facilitybuilding/management?lang=' + this.transloco.getActiveLang();
        break;

      // harita seçildiyse
      case HomeSelectionEnum.Map:
        window.location.href = environment.tempUrl + '/maps?lang=' + this.transloco.getActiveLang();
        break;

      // kayıt işlemi başarısız olursa ana sayfaya yönlendiriyoruz.
      default:
        window.location.href = environment.tempUrl;
        break;
    }

  }
}

